import FolderHeader from './FolderHeader';

export default FolderHeader;
